module.exports = __webpack_public_path__ + "assets/rkxs7AJdBR.woff2";